import React from "react";
import "./style.css";

/* Legacy shared button, restyled to the redesign tokens (§2.7): the old
   white-with-black-fold gradient is retired. Secondary style — these render
   in long stacks (the admin button wall), where a wall of primary green
   would be worse than a wall of quiet white. API unchanged. */
function FawnButton({ pf1, buttonText }) {
  return (
    <div>
      <button className="fawn-button-legacy" onClick={() => pf1()}>
        {buttonText}
      </button>
    </div>
  );
}

export default FawnButton;
